export const ICONS = {
  ARROW_DROP_DOWN: 'arrow_drop_down',
  ARROW_DROP_UP: 'arrow_drop_up',
  PERSON_OFF: 'person_off',
  CLOSE: 'close',
  REFRESH: 'refresh',
  MAIL: 'mail',
  SPACE_DASHBOARD: 'space_dashboard',
  AUTORENEW: 'autorenew',
  LOGOUT: 'logout',
  GRID_VIEW: 'grid_view',
  ARROW_CIRCLE_DOWN: 'arrow_circle_down',
  ARROW_CIRCLE_UP: 'arrow_circle_up',
  QUESTION_CIRCLE: 'help_outline',
  PLUS_SQUARE: 'add_box',
  EXPAND_MORE: 'expand_more',
  ATTACH_FILE: 'attach_file',
  CLIPBOARD: 'assignment',
  DELETE: 'delete',
  TICK_ROUND: 'check_circle_outline',
  DOWNLOAD: 'download',
  UPLOAD: 'upload',
  EXPORT: 'open_in_new',
  USER_CIRCLE: 'account_circle',
  EXCLAMATION_CIRCLE: 'error_outline',
  EXCLAMATION_CIRCLE_FILLED: 'error',
  ARROW_RIGHT: 'east',
  COMMENT: 'textsms',
  DENSITY_MEDIUM: 'density_medium',
  ARROW_UPWARD: 'arrow_upward',
  ARROW_DOWNWARD: 'arrow_downward',
  LOCK: 'lock',
  LOCK_OPEN: 'lock_open',
  FILTER_ALT: 'filter_alt',
  CHECK_CIRCLE: 'check_circle',
  SYNC: 'sync',
  SCHEDULE: 'schedule',
  NOTIFICATIONS: 'notifications',
  INFO: 'info',
  CONTENT_COPY: 'content_copy',
  SEND: 'send',
  FILE_UPLOAD: 'file_upload',
  DESCRIPTION: 'description',
} as const

export const ICON_PATHS = {
  DMP_LOGO: 'assets/icon/dmp-default-logo.svg',
  INMAR_FAV: 'assets/icon/inmar_fav.ico',

  // Action Icons
  SPLIT: 'assets/icon/union-three.svg',
  DELETE_SPLIT: 'assets/icon/deletespliticon.svg',
  DELETE_CIRCLE: 'assets/icon/delete-circle.svg',
  HELP_ICON: 'assets/icon/help-icon.svg',

  // Sorting Icons
  ASCENDING_SORT: 'assets/icon/ascending-sort.svg',
  DESCENDING_SORT: 'assets/icon/descending-sort.svg',

  // Status/Alert Icons
  CIRCLE_WARNING: 'assets/icon/circle-warning.svg',
  EXCLAMATION_TRIANGLE_FILLED: 'assets/icon/exclamation-triangle-filled.svg',
  SUCCESS: 'assets/icon/success.png',
  MESSAGE: 'assets/icon/message.png',

  // Level/Section Icons
  LEVEL3: 'assets/icon/levelthree_create.svg',
  FIRST_SECTION: 'assets/icon/first_section.png',
  SECOND_SECTION: 'assets/icon/second_section.png',
  THIRD_SECTION: 'assets/icon/third_section.png',

  // Dispute Icons
  DISPUTE_1: 'assets/icon/dispute_1.png',
  DISPUTE_2: 'assets/icon/dispute_2.png',
} as const
